// src/components/VendorsStrip.jsx
import { Link } from 'react-router-dom'

export default function VendorsStrip() {
  // Tu peux remplacer par de vraies données Firestore plus tard
  const vendors = [
    {
      id: 'vendor1',
      name: 'USA Beauty Shop',
      tagline: 'Cosmétiques & soins importés des USA.',
      logo: '/logos/vendor-beauty.png', // ou null si pas encore
    },
    {
      id: 'vendor2',
      name: 'AutoParts Pro',
      tagline: 'Pièces auto & accessoires pour votre véhicule.',
      logo: '/logos/vendor-auto.png',
    },
    {
      id: 'vendor3',
      name: 'Baby & Family',
      tagline: 'Tout pour bébé et la maison.',
      logo: '/logos/vendor-baby.png',
    },
  ]

  if (!vendors.length) return null

  return (
    <section className="mb-5">
      <div className="card-modern p-3">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h3 className="m-0">Nos vendeurs partenaires</h3>
          <span className="text-muted small">
            Vendeurs vérifiés sur GoShop
          </span>
        </div>
        <div className="row row-cols-1 row-cols-md-3 g-3">
          {vendors.map((v) => (
            <div className="col" key={v.id}>
              <div className="card-modern h-100 p-3 d-flex">
                {v.logo && (
                  <div className="me-3 d-flex align-items-center">
                    <img
                      src={v.logo}
                      alt={v.name}
                      style={{
                        width: 48,
                        height: 48,
                        objectFit: 'contain',
                        borderRadius: '12px',
                      }}
                    />
                  </div>
                )}
                <div className="d-flex flex-column">
                  <div className="fw-semibold" style={{ color: 'var(--text)' }}>
                    {v.name}
                  </div>
                  <div className="text-muted small mb-2">
                    {v.tagline}
                  </div>
                  <Link
                    to={`/catalog?vendor=${encodeURIComponent(v.id)}`}
                    className="small text-primary fw-semibold mt-auto"
                  >
                    Voir les produits &raquo;
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
